import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../../utils/redux';
import normalize from '../normalizers/inspection-normalizer';
import { APPOINTMENT_PROGRESS_TYPES } from '../progress-types';

export const consts = createReqConsts('appointment-form', 'inspection-req', [
  'SET_ENTITY',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'post',
  slug: ['form_inspections'],
});

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  ...rootState,
  ids: [],
  entities: {},
  requiredSteps: [],
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case consts.SUCCEED: {
      const {
        result: ids,
        entities: { inspections: entities },
        requiredSteps,
      } = normalize(payload);

      return {
        ...state,
        sending: false,
        succeed: true,
        requiredSteps,
        ids,
        entities,
      };
    }

    case consts.SET_ENTITY: {
      return {
        ...state,
        entities: {
          ...state.entities,
          ...payload,
        },
      };
    }

    case APPOINTMENT_PROGRESS_TYPES.CLEAR: {
      return initialState;
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/inspection-req.js